/* ==========================================================================
   LUNÉA — Toevoegen aan winkelwagen, zonder afhankelijkheden

   Waarom dit bestand alles zelf doet:
   het basisthema koppelt AJAX alleen aan formulieren met id AddToCartForm-*,
   en vult de lade via window.theme.miniCart. De LUNÉA-secties gebruiken die
   conventie niet. Deze laag doet daarom zelf: verzenden, winkelwagen ophalen,
   teller/totaal/regels bijwerken en de lade openen.

   Werkt window.theme.miniCart wél, dan laten we dat het renderen doen — die kent de
   extra blokken (cadeauverpakking, upsell).

   v3.16.1 — gemeten in de browser (preview v3.16.0), twee oorzaken:
   1. bindAll() crashte op het eerste formulier. Elk winkelwagenformulier bevat
      <input name="id"> (de variant). Daardoor geeft form.id dát invoerveld
      terug in plaats van het id-attribuut (DOM clobbering), en gooide
      form.id.indexOf(...) een TypeError. Gevolg: op de collectiepagina werd
      geen enkel formulier gekoppeld (0 van 16), de knop deed een gewone POST
      en de bezoeker belandde op /cart. Nu: altijd getAttribute('id').
   2. De homepage-secties (Uitgelicht, Videocollectie, Laatst bekeken) voegen
      zelf toe via fetch en sturen daarna cart:updated / cart:refresh /
      ajaxCart.afterCartLoad. Niemand die de teller en de lade beheert luisterde
      daarnaar: product wel toegevoegd, teller en lade bleven stil. Nu wel.

   Lukt het openen niet, dan verschijnt er een diagnosepaneel in beeld met de
   exacte staat — alleen in preview/dev (thema niet gepubliceerd), in de
   theme editor of met ?lu-debug=1 in de URL. Nooit bij klanten op het live thema.
   ========================================================================== */
(function () {
  'use strict';

  if (window.LuneaATC) return;

  function log() {
    if (!window.console || !console.info) return;
    console.info.apply(console, ['%c[LUNÉA cart]', 'color:#8e534e;font-weight:700']
      .concat([].slice.call(arguments)));
  }

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  /* Winkelwagenpagina: daar is er geen lade (block-cart.liquid laat de class
     cardraw daar bewust weg). Na toevoegen herladen we de pagina, net zoals
     theme.js dat doet, zodat de tabel klopt. */
  function isCartPage() {
    if (window.theme && typeof window.theme.cartpage === 'boolean') return window.theme.cartpage;
    return /\/cart\/?$/.test(location.pathname);
  }

  /* Diagnose alleen tonen waar het nuttig is: preview, dev, editor of ?lu-debug. */
  function debugMode() {
    try {
      if (/[?&]lu-debug\b/.test(location.search)) return true;
      if (window.Shopify && Shopify.designMode) return true;
      if (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') return true;
    } catch (e) {}
    return false;
  }

  /* ---------------- De lade ---------------- */

  function cartEl() {
    return document.querySelector('.js-mini-cart');
  }

  function open() {
    var el = cartEl();
    if (!el) { log('GEEN .js-mini-cart gevonden'); return; }
    if (isCartPage()) return;
    // `cardraw` hangt in de markup aan de themainstelling "Cart Drawer".
    // Staat die uit, dan matcht .cardraw.active nooit. Zelf zetten dus.
    if (!el.classList.contains('cardraw')) el.classList.add('cardraw');
    el.classList.add('active');
    log('lade geopend:', el.className);
  }

  function close() {
    var el = cartEl();
    if (el) el.classList.remove('active');
  }

  /* ---------------- Zelf renderen ---------------- */

  function money(cents) {
    if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney && window.theme.moneyFormat) {
      try { return window.theme.Currency.formatMoney(cents, window.theme.moneyFormat); } catch (e) {}
    }
    var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat('nl-BE', { style: 'currency', currency: code }).format(cents / 100);
    } catch (e) {
      return '\u20ac ' + (cents / 100).toFixed(2).replace('.', ',');
    }
  }

  function itemHtml(item, line) {
    var img = item.image ? item.image + '&width=160' : '';
    return '<div class="mini-cart-item">' +
      '<a class="mini-cart-image " href="' + item.url + '"><span class="d-block mini-cart-img">' +
      (img ? '<img src="' + img + '" alt="" loading="lazy" width="80" height="80"/>' : '') +
      '</span></a>' +
      '<div class="mini-cart-meta">' +
      '<div class="mb-1"><a href="' + item.url + '">' + item.product_title + '</a></div>' +
      '<span>' + money(item.price) + '</span> x ' + item.quantity +
      '<div class="d-flex align-items-center mt-2 justify-content-between">' +
      '<div class="js-qty mt-1">' +
      '<input data-line="' + line + '" type="text" min="0" class="change-minicart js-qty__input" pattern="[0-9]*" value="' + item.quantity + '">' +
      '<button type="button" class="js-qty__adjust js-qty__minus" data-lu-step="-1">\u2212</button>' +
      '<button type="button" class="js-qty__adjust js-qty__plus" data-lu-step="1">+</button>' +
      '</div>' +
      '<button class="btn js-remove-mini-cart link pr-0" data-line="' + line + '" data-id="' + item.id + '">' +
      ((window.theme && window.theme.strings && window.theme.strings.remove) || 'Verwijderen') +
      '</button></div></div></div>';
  }

  /* Balken "gratis verzending" bijwerken: die van het thema in de lade en de
     LUNÉA-balk in secties. Voorheen bleef de balk in de lade op het oude
     bedrag staan na toevoegen. */
  function updateFreeShipping(cart) {
    try {
      if (window.theme && window.theme.freeShipping && window.theme.freeShipping.load) window.theme.freeShipping.load(cart);
    } catch (e) {}
    try {
      if (window.LuneaTheme && window.LuneaTheme.refreshCart) window.LuneaTheme.refreshCart();
    } catch (e) {}
  }

  function render(cart) {
    // Teller en totaal altijd zelf zetten: dat moet werken, ook als
    // window.theme.miniCart ontbreekt.
    each('.js-cart-count', function (el) { el.textContent = String(cart.item_count); });
    each('.js-cart-total', function (el) { el.innerHTML = money(cart.total_price); });
    each('.js-cart-bottom, .drawer-crossell', function (el) {
      el.style.display = cart.item_count === 0 ? 'none' : '';
    });
    updateFreeShipping(cart);

    if (window.theme && window.theme.miniCart && window.theme.miniCart.generateCart) {
      // Het thema kent de extra blokken; laat dat het lijstwerk doen.
      try { window.theme.miniCart.generateCart(); log('regels via window.theme.miniCart'); return; }
      catch (e) { log('window.theme.miniCart gaf een fout, val terug op eigen render', e); }
    }

    var list = document.querySelector('.js-mini-cart-content');
    if (!list) { log('GEEN .js-mini-cart-content gevonden'); return; }
    var html = '';
    for (var i = 0; i < cart.items.length && i < 5; i++) html += itemHtml(cart.items[i], i + 1);
    list.innerHTML = html;
    log('regels zelf gerenderd:', cart.items.length);
  }

  function each(sel, fn) {
    Array.prototype.forEach.call(document.querySelectorAll(sel), fn);
  }

  function refresh() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); return cart; });
  }

  /* Huidige stand van de teller in de header, zoals de bezoeker hem ziet. */
  function shownCount() {
    var el = document.querySelector('.js-cart-count');
    var n = el ? parseInt(String(el.textContent).replace(/[^0-9]/g, ''), 10) : NaN;
    return isNaN(n) ? 0 : n;
  }

  /* ---------------- Diagnose ---------------- */

  function visible(el) {
    if (!el) return false;
    var cs = getComputedStyle(el);
    var r = el.getBoundingClientRect();
    return cs.visibility !== 'hidden' && cs.display !== 'none' &&
           parseFloat(cs.opacity) > 0.05 && r.width > 40 &&
           r.right > 0 && r.left < window.innerWidth;
  }

  function diagnose() {
    if (document.getElementById('lu-diag')) return;
    var mini = cartEl();
    var panel = mini && mini.querySelector('.mini-cart-content');
    var cs = panel ? getComputedStyle(panel) : null;
    var r = panel ? panel.getBoundingClientRect() : null;
    var sheets = [];
    try {
      for (var i = 0; i < document.styleSheets.length; i++) {
        var h = document.styleSheets[i].href || '';
        if (h.indexOf('cart-draw') > -1) sheets.push('cart-draw.css');
      }
    } catch (e) {}

    var rows = [
      ['.js-mini-cart', mini ? mini.className : 'NIET GEVONDEN'],
      ['.mini-cart-content', panel ? 'gevonden' : 'NIET GEVONDEN'],
      ['position', cs ? cs.position : '-'],
      ['transform', cs ? cs.transform : '-'],
      ['opacity', cs ? cs.opacity : '-'],
      ['visibility', cs ? cs.visibility : '-'],
      ['display', cs ? cs.display : '-'],
      ['z-index', cs ? cs.zIndex : '-'],
      ['rect', r ? Math.round(r.left) + ',' + Math.round(r.top) + ' ' + Math.round(r.width) + 'x' + Math.round(r.height) : '-'],
      ['cart-draw.css', sheets.length ? 'geladen' : 'NIET GELADEN'],
      ['window.theme.miniCart', (window.theme && window.theme.miniCart) ? 'aanwezig' : 'ONTBREEKT'],
      ['jQuery', window.jQuery ? 'aanwezig' : 'ONTBREEKT']
    ];

    log('lade niet zichtbaar na toevoegen', rows);
    if (!debugMode()) return;

    var box = document.createElement('div');
    box.id = 'lu-diag';
    box.style.cssText = 'position:fixed;left:12px;bottom:12px;z-index:2147483647;max-width:92vw;' +
      'background:#241e20;color:#fff;font:12px/1.5 ui-monospace,Menlo,monospace;padding:14px 16px;' +
      'border-radius:10px;box-shadow:0 12px 32px rgba(0,0,0,.4)';
    var html = '<div style="font-weight:700;margin-bottom:8px;color:#f7b8b2">LUNÉA — lade ging niet open</div>';
    for (var k = 0; k < rows.length; k++) {
      html += '<div><span style="color:#c9a9a5">' + rows[k][0] + ':</span> ' + rows[k][1] + '</div>';
    }
    html += '<button style="margin-top:10px;background:#8e534e;color:#fff;border:0;border-radius:6px;padding:5px 12px;cursor:pointer">sluiten</button>';
    box.innerHTML = html;
    box.querySelector('button').onclick = function () { box.remove(); };
    document.body.appendChild(box);
  }

  function checkOpened() {
    if (isCartPage()) return;
    window.setTimeout(function () {
      // In een verborgen tab lopen CSS-transities niet: het paneel blijft dan
      // op translateX(100%) staan terwijl .cardraw.active er wél op staat.
      // Meten heeft daar geen zin en gaf een vals alarm.
      if (document.hidden) return;
      var mini = cartEl();
      if (!visible(mini && mini.querySelector('.mini-cart-content'))) diagnose();
    }, 700);
  }

  /* ---------------- Verzenden ---------------- */

  /* Signaal voor andere scripts (o.a. lunea-routine.js: extra item terugzetten
     als het hoofdproduct niet toegevoegd kon worden). detail: { form, variantId } */
  function emit(name, detail) {
    try { document.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) {}
  }

  /* Foutmelding bij de koopknop.
     v3.22.1: hier stond theme.alert.new(). Die roept $.growl aan, maar het thema laadt
     die plug-in niet. De TypeError brak de promise-keten af: de knop bleef laden en de
     bezoeker zag geen melding. Gemeten op de preview met een 422 van Shopify ("De
     maximale hoeveelheid van dit artikel zit al in je winkelwagen.").
     Productpagina: onder de knoprij. Elders (productkaarten, waar het formulier zelf
     een rij is) net na het formulier, zodat die rij niet uitrekt. */
  function errorBox(form) {
    if (form.querySelector('.lu-buy__row')) return form.querySelector('[data-lu-atc-error]');
    var next = form.nextElementSibling;
    return next && next.hasAttribute('data-lu-atc-error') ? next : null;
  }

  function showError(form, msg) {
    var box = errorBox(form);
    if (!box) {
      box = document.createElement('p');
      box.className = 'lu-buy__error';
      box.setAttribute('data-lu-atc-error', '');
      box.setAttribute('role', 'alert');
      var row = form.querySelector('.lu-buy__row');
      if (row) row.parentNode.insertBefore(box, row.nextSibling);
      else if (form.parentNode) form.parentNode.insertBefore(box, form.nextSibling);
      else form.appendChild(box);
    }
    box.hidden = false;
    box.textContent = msg;
    // Via de sticky koopbalk staat het formulier buiten beeld: breng de melding in beeld.
    // Een frame later, als de scroll-lock van de lade (lunea-cart.js) weg is.
    var later = window.requestAnimationFrame ? function (fn) { window.requestAnimationFrame(fn); } : function (fn) { window.setTimeout(fn, 16); };
    later(function () {
      var r = box.getBoundingClientRect();
      if (r.top >= 0 && r.bottom <= (window.innerHeight || document.documentElement.clientHeight)) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      box.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  function hideError(form) {
    var box = errorBox(form);
    if (box) { box.hidden = true; box.textContent = ''; }
  }

  function submit(form) {
    var btn = form.querySelector('[type="submit"]');
    var idInput = form.querySelector('[name="id"]');
    var variantId = idInput ? idInput.value : '';
    var added = false;
    hideError(form);
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    open();

    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new URLSearchParams(new FormData(form))
    })
      .then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw j; return j; });
      })
      .then(function () {
        log('/cart/add.js gelukt');
        added = true;
        emit('lunea:cart:added', { form: form, variantId: variantId });
        if (isCartPage()) { window.location.reload(); return; }
        return refresh().then(checkOpened);
      })
      .catch(function (err) {
        close();
        log('FOUT:', err);
        // Alleen als het toevoegen zelf mislukte, niet bij een fout bij het verversen:
        // dan zit het product wel in de wagen en klopt "niet gelukt" niet.
        if (added) return;
        emit('lunea:cart:error', { form: form, variantId: variantId, error: err });
        // Shopify zet de uitleg voor de klant in description (in de taal van de winkel);
        // message is "Cart Error" of een technische fout ("Failed to fetch").
        var msg = (err && typeof err.description === 'string' && err.description) || 'Toevoegen is niet gelukt.';
        try { showError(form, msg); } catch (e) { log('melding tonen mislukt:', e); }
      })
      .then(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
      });
  }

  function onSubmit(e) {
    e.preventDefault();
    log('formulier overgenomen');
    submit(e.currentTarget);
  }

  function bindAll() {
    each('form[action*="/cart/add"]', function (form) {
      // Per formulier afgeschermd: één afwijkend formulier mag nooit meer de
      // rest van de pagina ontkoppeld laten.
      try {
        if (form.getAttribute('data-lu-ajax') === 'on') return;
        // NOOIT form.id of form.className lezen: <input name="id"> in het
        // formulier overschaduwt die eigenschappen. Altijd de attributen.
        var fid = form.getAttribute('id') || '';
        var fcls = form.getAttribute('class') || '';
        // Formulieren die theme.js zelf via window.AjaxCart koppelt, laten we
        // met rust — anders gaat het product er twee keer in.
        if (fid.indexOf('AddToCartForm-') === 0) return;
        if (/(^|\s)customform-/.test(fcls)) return;
        form.setAttribute('data-lu-ajax', 'on');
        form.addEventListener('submit', onSubmit);
      } catch (err) {
        log('formulier niet gekoppeld:', err);
      }
    });
  }

  /* ---------------- Toevoegen vanuit andere secties ----------------
     Uitgelicht, Videocollectie en Laatst bekeken voegen zelf toe en sturen
     daarna drie events tegelijk. Eén keer verversen per toevoeging, en de lade
     alleen openen als er echt iets bij kwam: een app die alleen "ververs" roept,
     mag de lade niet zomaar openklappen. */
  var extTimer = null;
  function onExternalCartEvent() {
    window.clearTimeout(extTimer);
    extTimer = window.setTimeout(function () {
      var before = shownCount();
      refresh().then(function (cart) {
        log('winkelwagen-event ontvangen, aantal', before, '->', cart.item_count);
        if (!cart || cart.item_count <= before) return;
        if (isCartPage()) { window.location.reload(); return; }
        open();
        checkOpened();
      }).catch(function (err) { log('verversen na event mislukt:', err); });
    }, 40);
  }
  ['cart:updated', 'cart:refresh', 'ajaxCart.afterCartLoad'].forEach(function (name) {
    document.addEventListener(name, onExternalCartEvent);
  });

  /* Aantal en verwijderen binnen de lade, voor het geval theme.js het niet
     doet. Gedelegeerd en gemarkeerd, zodat het nooit dubbel vuurt. */
  document.addEventListener('click', function (e) {
    if (window.theme && window.theme.miniCart) return;
    var t = e.target.closest && e.target.closest('.js-mini-cart [data-lu-step], .js-mini-cart .js-remove-mini-cart');
    if (!t) return;
    e.preventDefault();
    var line, qty;
    if (t.hasAttribute('data-lu-step')) {
      var input = t.parentNode.querySelector('.js-qty__input');
      line = parseInt(input.getAttribute('data-line'), 10);
      qty = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(t.getAttribute('data-lu-step'), 10));
    } else {
      line = parseInt(t.getAttribute('data-line'), 10);
      qty = 0;
    }
    fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(render);
  });

  window.LuneaATC = { submit: submit, open: open, close: close, refresh: refresh, diagnose: diagnose, bind: bindAll };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindAll);
  else bindAll();

  if (window.MutationObserver) {
    var t = null;
    new window.MutationObserver(function () {
      window.clearTimeout(t);
      t = window.setTimeout(bindAll, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', bindAll);
})();
